import { Container, Icon, Tag, Tooltip } from "@fluidattacks/design";
import type { FC } from "react";

import { ReachabilityStatus } from "gql/graphql";
import { translate } from "utils/translations/translate";

interface IReachabilityTag {
  readonly reachabilityStatus: ReachabilityStatus;
}

const ReachabilityTag: FC<IReachabilityTag> = ({
  reachabilityStatus,
}): JSX.Element => {
  switch (reachabilityStatus) {
    case ReachabilityStatus.Reachable:
      return (
        <Tag
          icon={"hexagon-exclamation"}
          iconColor={"#FFFFFF"}
          priority={"high"}
          tagLabel={translate.t(
            "searchFindings.tabVuln.vulnTable.reachability.reachable.label",
          )}
          variant={"error"}
        />
      );
    case ReachabilityStatus.PotentiallyReachable:
      return (
        <Tag
          icon={"triangle-exclamation"}
          iconColor={"#FFFFFF"}
          priority={"high"}
          tagLabel={translate.t(
            "searchFindings.tabVuln.vulnTable.reachability.potentially_reachable.label",
          )}
          variant={"warning"}
        />
      );
    case ReachabilityStatus.Latent:
    default:
      return (
        <Tag
          icon={"circle-exclamation"}
          iconColor={"#B54708"}
          priority={"medium"}
          tagLabel={translate.t(
            "searchFindings.tabVuln.vulnTable.reachability.latent.label",
          )}
          variant={"warning"}
        />
      );
  }
};

const reachabilityFormatter = (value: ReachabilityStatus): JSX.Element => {
  return (
    <Container display={"flex"} gap={0.25}>
      <ReachabilityTag reachabilityStatus={value} />
      <Tooltip
        id={`${value.toLocaleLowerCase()}-tag-tooltip`}
        place={"right"}
        tip={translate.t(
          `searchFindings.tabVuln.vulnTable.reachability.${value.toLocaleLowerCase()}.tooltip`,
        )}
      >
        <Icon
          icon={"circle-info"}
          iconColor={"#2F394B"}
          iconSize={"sm"}
          iconType={"fa-light"}
        />
      </Tooltip>
    </Container>
  );
};

export { reachabilityFormatter };
